import { connect } from 'react-redux';
import { reduxForm, formValueSelector } from 'redux-form';
import { fetchPurchasePivotChartOrders, fetchPurchasePivotCharts, clearDuplicatedPurchasePivotChart } from '../../actions/purchaseOrders_actions';
import PurchasePivotChart from '../../components/Purchase/purchasePivotChart';

let purchasePivotChart = reduxForm({
  form: 'purchasePivotChart',
})(PurchasePivotChart);

const selector = formValueSelector('purchasePivotChart');

function mapStateToProps(state) {
    return {
      purchasePivotChartOrdersIsLoading: state.purchaseOrders.purchasePivotChartOrdersIsLoading,
      purchasePivotChartOrders: state.purchaseOrders.purchasePivotChartOrders,
      purchasePivotChartOrdersError: state.purchaseOrders.purchasePivotChartOrdersError,
    };
}

export default connect(mapStateToProps, { fetchPurchasePivotChartOrders, fetchPurchasePivotCharts, clearDuplicatedPurchasePivotChart })(purchasePivotChart);



// WEBPACK FOOTER //
// ./master/jsx/containers/Purchase/purchasePivotChart.jsx